import { JetView } from 'webix-jet';

/**
 * Class representing the details view for a casino report.
 * @extends JetView
 */
export default class detailsCasinoReportView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Main information layout
        const main_info = {
            margin: 10,
            rows: [
                {
                    cols: [
                        {
                            rows: [
                                {
                                    view: 'text',
                                    name: 'Id',
                                    label: "<span class='icon-drivers-license-o'></span>" + _('Id'), // ID field
                                    labelPosition: 'top',
                                    placeholder: _('Id'),
                                    invalidMessage: _('A ID is required'), // Validation message
                                    readonly: true, // Read-only field
                                },
                                {
                                    view: 'text',
                                    name: 'TransactionId',
                                    label: _('Transacción Id'), // Transaction ID field
                                    labelPosition: 'top',
                                    placeholder: _('Transacción Id'),
                                    readonly: true, // Read-only field
                                },
                                {
                                    view: 'text',
                                    name: 'Type',
                                    label: _('Tipo'), // Type field
                                    labelPosition: 'top',
                                    placeholder: _('Tipo'),
                                    readonly: true, // Read-only field
                                },
                                {
                                    view: 'text',
                                    name: 'Amount',
                                    label: _('Valor'), // Amount field
                                    labelPosition: 'top',
                                    placeholder: _('Valor'),
                                    readonly: true, // Read-only field
                                    id: 'Valor', // ID for later reference
                                },
                            ],
                        },
                        {
                            rows: [
                                {
                                    view: 'textarea',
                                    name: 'Value',
                                    label: _('Envió'), // Value field
                                    labelPosition: 'top',
                                    placeholder: _('Envió'),
                                    readonly: true, // Read-only field
                                },
                                {
                                    view: 'textarea',
                                    name: 'Response',
                                    label: _('Respuesta'), // Response field
                                    labelPosition: 'top',
                                    placeholder: _('Respuesta'),
                                    readonly: true, // Read-only field
                                },
                                {
                                    id: 'buttonArrow', // Button for scrolling
                                    hidden: true, // Initially hidden
                                    width: 150,
                                    css: 'divButtonArrow',
                                    cols: [
                                        {},
                                        {
                                            view: 'button',
                                            value: "<span class='icon-arrow-up'></span>", // Button icon
                                            css: 'buttonArrow',
                                            align: 'right',
                                            bottom: 20,
                                            right: 35,
                                            width: 50,
                                            height: 60,
                                            on: {
                                                onItemClick: function () {
                                                    $$('a5').scrollTo(100, 0); // Scroll action
                                                },
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                },
            ],
        };

        // Left main layout
        const left_main = {
            gravity: 3,
            minWidth: 100,
            margin: 10,
            rows: [main_info],
        };

        // Upper section layout for larger screens
        const upper_section = {
            multiview: true,
            scroll: true,
            cols: [left_main, { gravity: 1, minWidth: 20 }],
        };

        // Upper section layout for narrow screens
        const upper_section_narrow = {
            cols: [
                {
                    gravity: 4,
                    margin: 10,
                    rows: [main_info],
                },
            ],
        };

        // Return the main form configuration
        return {
            view: 'form',
            id: 'formDetails', // Form ID
            rows: [screen !== 'small' ? upper_section : upper_section_narrow], // Conditional layout based on screen size
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} form - The form instance.
     */
    init(form) {
        this.on(this.app, 'casinoTransDetail:select', (person) => {
            form.setValues(person); // Set form values based on selected person
            this.$$('Valor').setValue(webix.i18n.priceFormat(person.Amount)); // Format and set amount value
        });

        // Show buttonArrow if screen width is less than 500
        webix.ready(function () {
            if (screen.width < 500) {
                $$('buttonArrow').show();
            }
        });
    }
}

// FILE DOCUMENTED
